import images from '@/assets/images'
import { getImage } from '@/utils/utils'
import './index.less'

type Props = {
  player?: { name: string; avatarUrl: string }
  type: 'robot' | 'human'
  position: 'left' | 'right'
}

const ChessProfile = ({ player, type, position }: Props) => {
  return (
    <div className={`profile ${position}`}>
      <img
        src={player?.avatarUrl ? getImage(player.avatarUrl) : images.avatar_default}
        className="avatar"
        alt=""
      />
      {type === 'robot' ? (
        <div className="name">元萝卜AI下棋机器人</div>
      ) : (
        <div className="name">{player?.name || '棋手'}</div>
      )}
    </div>
  )
}

export default ChessProfile
